<template>
<div class="chapter">
<div class="inner_page">
<div id="FM01">
<p class="fm-noindent"><a id="page_10"><b>Note</b></a></p><a id="page_10">
<p class="fm-noindent1">Terms relating to ufology are included in a glossary at the end of this book.</p>
</a></div><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_FM01.vue?ef1ac644